import { CODE_POINT_JOINER } from "~/constants/string";

const HIGH_SURROGATE_LOW_BOUND = 0xd800;
const HIGH_SURROGATE_HIGH_BOUND = 0xdbff;
const LOW_SURROGATE_LOW_BOUND = 0xdc00;
const FIRST_CODE_POINT_NOT_PRESENTABLE_WITH_ONE_POINT_VALUE = 0x10000;

export default function toCodePoint(unicodeSurrogates: string): string {
  const result = [];
  let previous = 0;

  for (let i = 0; i < unicodeSurrogates.length; i++) {
    const current = unicodeSurrogates.charCodeAt(i);

    if (previous) {
      result.push(
        (
          FIRST_CODE_POINT_NOT_PRESENTABLE_WITH_ONE_POINT_VALUE +
          ((previous - HIGH_SURROGATE_LOW_BOUND) << 10) +
          (current - LOW_SURROGATE_LOW_BOUND)
        ).toString(16)
      );
      previous = 0;
    } else if (
      HIGH_SURROGATE_LOW_BOUND <= current &&
      current <= HIGH_SURROGATE_HIGH_BOUND
    ) {
      previous = current;
    } else {
      result.push(current.toString(16));
    }
  }

  return result.join(CODE_POINT_JOINER);
}
